import React, { Component } from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import { TREE_EVENT } from 'shared/dictionaries/events';
import IconButton from 'material-ui/IconButton';

import Button from 'material-ui/Button';
import { Magnify } from 'mdi-material-ui';

import withAppStore from 'decorators/withAppStore';

import styles from 'styles/components/Search';

@withStyles(styles)
@withAppStore
@observer
export default class Search extends Component {

  render() {
    const { classes, isMobile } = this.props;

    if (isMobile){
      return (
        <IconButton onClick={ this.handleClick } disabled={ this.isLoading }>
            <Magnify />
        </IconButton>
      )
    }
    return (
      <Button variant="flat"
        onClick={ this.handleClick }
        disableFocusRipple
        className={ classes.button }
      >
        <Magnify /> Поиск
      </Button>
    );
  }

  @action.bound
  handleClick() {
    if (this.appStore.isSearchOpen){
      this.appStore.isSearchOpen = false;
      this.appStore.sendEvent(TREE_EVENT.CLOSE_INFO);
    }
    else {
      this.appStore.isSearchOpen = true;
      this.appStore.sendEvent(TREE_EVENT.SEARCH_OPEN);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/Search.js